angular.module('wbDashboard').controller('LogoutController',
    ['$rootScope', '$scope', '$uibModalStack', 'Auth', 'User', 'Message', 'Display', 'Session', '$timeout', '$window',
function ($rootScope, $scope, $uibModalStack, Auth, User, Message, Display, Session, $timeout, $window) {

    Auth.logout();

    $rootScope.$emit("AuthLoggedOut");

    //Session.clear();
    Session.clear('referral');
    Session.clear('referralName');
    User.clear();
    Display.setMenu(false);
    $uibModalStack.dismissAll("Logged out");
    Message.clearAll();
    if ($scope.$stateParams.message !== false && !Session.get('logout-message')) {
        Session.set('logout-message', {message: 'All logged out!', type: 'success'});
    }

    //  if directed to a url but then are directing to logout to login again,
    //    this controller happens to load before the url changes to the logout controller,
    //    so the original url search params are still there in the original location object
    var searchParams = $window.location.search || "";
    $timeout(function() {
        $window.location.replace("/dashboard/login" + searchParams);
    });
    // $scope.$state.go('public.login', {}, { reload: true }).then(function() {
    //     $timeout(function() {
    //         $window.location.reload(true);
    //     },500);
    // });
}]);
